module.exports = __webpack_public_path__ + "media/images/countryrect/md-d8c4eb0e5bdcabe7d09e33b092894304.svg";